<ng-container *ngIf="steps">
<app-card-info-steps 
    infoTitle="Sua jornada no Orca App"
    color="#6ad49b"
    infoDescription="Do primeiro orçamento ao pagamento, tudo em um só lugar."
    progressLabel="Primeiros passos"
    [showChart]="steps.has_first_proposal"
    [compact]="true"
    [steps]="steps"
    >

            <app-config-step
                title="Crie seu primeiro orçamento" 
                key="has_first_proposal"
                (onAction)="doAction($event)"
                color="#6ad49b"
                [isComplete]="steps.has_first_proposal">
            </app-config-step>

            <app-config-step 
                title="Envie o orçamento para seu cliente" 
                key="has_sent_proposal"
                (onAction)="doAction($event)"
                color="#6ad49b"
                [isComplete]="steps.has_sent_proposal">
            </app-config-step>

            <app-config-step 
                title="Aprove um orçamento" 
                key="has_approved_proposal"
                (onAction)="doAction($event)"
                color="#6ad49b"
                [isComplete]="steps.has_approved_proposal">
            </app-config-step>

            <app-config-step 
                title="Fature um orçamento" 
                key="has_billed_proposal"
                (onAction)="doAction($event)"
                color="#6ad49b"
                [isComplete]="steps.has_billed_proposal">
            </app-config-step>

            <app-config-step 
                title="Marque um orçamento como pago" 
                key="has_paid_proposal"
                (onAction)="doAction($event)"
                color="#6ad49b"
                [isComplete]="steps.has_paid_proposal">
            </app-config-step>


    
   

    
</app-card-info-steps>
</ng-container>
